{
  "version": 1,
  "asset_id": "facbe8fd-26df-42a2-b83e-cd0ca28d4bc8",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/facbe8fd-26df-42a2-b83e-cd0ca28d4bc8/brand-lippert.png",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/facbe8fd-26df-42a2-b83e-cd0ca28d4bc8/brand-lippert.png",
  "original_filename": "brand-lippert.png",
  "size": 12218,
  "content_type": "image/png",
  "created_at": "2026-07-14T02:53:47Z"
}
